/** @format */

/* eslint-disable */
import React, { useState } from 'react'
import Swal from 'sweetalert2'
import BreadCrumb from '../../../../../../Components/BreadCrumb/Index'
import Loader from '../../../../../../Components/Loaders/Loader'
import ListDebitBatches from '../../../../../../Components/ReUsables/BatchProcedures/DebitBatches/ListDebitBatches'
import localize from '../../../../../../Global/Localize'
import {
  batchAuthOptions,
  batchStatus,
} from '../../../../../../Global/enumeration'
import { showNotification } from '../../../../../../Helpers/Notification/ShowNotification'
import { putData } from '../../../../../../Helpers/webApi'
import { GlobalValidationErrors } from '../../../../../../Validation/ValidationState'
import AuthorizeDebitBatch from './AuthorizeDebit/AuthorizeDebit'

function Debit() {
  const [isBusy, setIsBusy] = useState(false)
  const [mode, setMode] = useState(null)
  const [shortage, setShortage] = useState(null)
  const [batch, setBatch] = useState({
    batchAuthOption: Number(Object.keys(batchAuthOptions)[0]),
  })
  const [globalValidationErrors, setGlobalValidationErrors] =
    GlobalValidationErrors.use()

  const clearValidation = column => {
    setGlobalValidationErrors(g => {
      delete g[column]
      return g
    })
  }
  const handleSelectAuthBatch = data => {
    if (data?.status !== Object.keys(batchStatus)[3])
      return Swal.fire({
        icon: 'error',
        title: 'Operation not allowed!',
        text: 'You can only authorize a batch whose status is audited!',
      })

    setBatch({
      ...data,
      ...batch,
    })
    setMode('authorize')
  }

  const handleClose = () => {
    setMode(null)
    setBatch({
      batchAuthOption: Number(Object.keys(batchAuthOptions)[0]),
    })

    clearValidation('Remarks')
  }

  const handleAuthorizeBatch = async () => {
    setIsBusy(true)
    const url = '/DebitBatch/authorize-debit-batch'

    if (!batch?.authorizationRemarks)
      return GlobalValidationErrors.set({
        Remarks: {
          message: 'Remarks is required',
        },
      })

    if (shortage === 0)
      return Swal.fire({
        icon: 'error',
        title: 'Operation not allowed!',
        text: 'The shortage amount  should not be zero',
      })

    const { success } = await putData(
      url,
      {
        debitBatch: batch,
        batchAuthOption: batch.batchAuthOption,
      },
      false
    )

    if (success) {
      handleClose()
      showNotification('Authorize Debit Batch', 'success')
    }

    setIsBusy(false)
  }

  return (
    <>
      {mode && (
        <AuthorizeDebitBatch
          batch={batch}
          handleClose={handleClose}
          mode={mode}
          setBatch={setBatch}
          clearValidation={clearValidation}
          globalValidationErrors={globalValidationErrors}
          handleAuthorizeBatch={handleAuthorizeBatch}
          isBusy={isBusy}
        />
      )}
      <BreadCrumb
        tree={[
          localize('accountsManagement'),
          localize('batchProcedures'),
          localize('verification'),
          localize('debit'),
        ]}
      />
      <div className="card bg-white rounded">
        <div className="card-body">
          {isBusy ? (
            <Loader />
          ) : (
            <>
              <ListDebitBatches
                showAuthorize
                status={Object.keys(batchStatus)[3]}
                handleSelectAuthBatch={handleSelectAuthBatch}
                getShortage={v => setShortage(v)}
              />
            </>
          )}
        </div>
      </div>
    </>
  )
}

export default Debit
